const Title = ({
    text
}) => {
  const base = 'text-headingCardsMobile md:text-headingCardsDesktop text-center md:text-left text-umber font-ttDrugsTrial'
  return (
    <span className={base}>
      {text}
    </span>
  )
}

export default Title